import { Box, Tooltip, IconButton, Modal, Backdrop, Fade } from "@mui/material";
import {
    FaRegCopy,
    FaCheck,
    FaDownload,
    FaWhatsapp,
    FaFacebookF,
} from "react-icons/fa";
import ShareLinkRow from "./ShareLinkRow";
import { useState } from "react";

export default function ShareModal({ open, setOpen, shareLink }) {
    const [copied, setCopied] = useState(false);

    const handleCopy = () => {
        navigator.clipboard.writeText(shareLink);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    const handleShare = (platform) => {
        let url = "";
        const encodedLink = encodeURIComponent(shareLink);

        switch (platform) {
            case "whatsapp":
                // Pre-filled creative message for WhatsApp
                url = `https://wa.me/?text=${encodeURIComponent(
                    "Check out Elmas Coffee! Premium blends and endless choices: " +
                        shareLink,
                )}`;
                break;
            case "facebook":
                // Pre-filled message for Facebook share
                url = `https://www.facebook.com/sharer/sharer.php?u=${encodedLink}&quote=${encodeURIComponent(
                    "Discover Elmas Coffee! Premium blends worth tasting!",
                )}`;
                break;
            default:
                break;
        }

        window.open(url, "_blank");
    };
    return (
        <Modal
            open={open}
            onClose={() => setOpen(false)}
            closeAfterTransition
            slots={{ backdrop: Backdrop }}
            slotProps={{
                backdrop: {
                    timeout: 500,
                    sx: {
                        backdropFilter: "blur(6px)",
                        backgroundColor: "rgba(0,0,0,0.3)",
                    },
                },
            }}
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}>
            <Fade in={open}>
                <Box
                    sx={{
                        width: { xs: "90%", sm: 400 },
                        background: "rgba(255,255,255,0.85)",
                        borderRadius: 3,
                        p: 3,
                        boxShadow: "0 20px 50px rgba(0,0,0,0.2)",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: 2,
                        maxHeight: "90vh",
                        overflowY: "auto",
                        transform: open ? "scale(1)" : "scale(0.9)",
                        transition: "transform 0.3s ease, opacity 0.3s ease",
                    }}>
                    <Box
                        sx={{
                            width: 250,
                            height: 250,
                            mb: 2,
                            mx: "auto",
                            position: "relative",
                        }}>
                        <img
                            src="/media/elmascoffee.png"
                            alt="QR Code"
                            style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "contain",
                                borderRadius: 8,
                            }}
                        />

                        <Tooltip title="Download QR" arrow>
                            <IconButton
                                size="small"
                                sx={{
                                    position: "absolute",
                                    top: -10,
                                    right: -10,
                                    background: "rgba(255,255,255,0.9)",
                                    "&:hover": {
                                        background: "rgba(255,255,255,1)",
                                    },
                                    boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                                }}
                                onClick={() => {
                                    const link = document.createElement("a");
                                    link.href = "/media/elmascoffee.png";
                                    link.download = "ElmasCoffee_QR.png";
                                    link.click();
                                }}>
                                <FaDownload size={14} />
                            </IconButton>
                        </Tooltip>
                    </Box>

                    <Box sx={{ display: "flex", gap: 2, mb: 1 }}>
                        <Tooltip
                            title={copied ? "Copied!" : "Copy Linked"}
                            arrow>
                            <IconButton
                                sx={{
                                    background: "#d7d7d7",
                                    "&:hover": { background: "#d5d5d5" },
                                }}
                                onClick={handleCopy}>
                                {copied ? <FaCheck /> : <FaRegCopy />}
                            </IconButton>
                        </Tooltip>

                        <Tooltip title="Share on WhatsApp" arrow>
                            <IconButton
                                sx={{
                                    background: "#25D366",
                                    "&:hover": { background: "#1DA851" },
                                    color: "#fff",
                                }}
                                onClick={() => handleShare("whatsapp")}>
                                <FaWhatsapp />
                            </IconButton>
                        </Tooltip>

                        <Tooltip title="Share on Facebook" arrow>
                            <IconButton
                                sx={{
                                    background: "#4267B2",
                                    "&:hover": { background: "#334d9e" },
                                    color: "#fff",
                                }}
                                onClick={() => handleShare("facebook")}>
                                <FaFacebookF />
                            </IconButton>
                        </Tooltip>
                    </Box>

                    <ShareLinkRow shareLink={shareLink} />
                </Box>
            </Fade>
        </Modal>
    );
}
